import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from '../../service/app.service';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  constructor(
    private appService: AppService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let idEnte = this.appService.user.idEnte?.toString() ?? "";

    request = request.clone({
      setHeaders: {
        'X-IdEnte': idEnte ?? "",
      }
    });

    return next.handle(request);
  }
}
